import { render } from "./ErrorpageView.vue?vue&type=template&id=60843c5e"
import script from "./ErrorpageView.vue?vue&type=script&lang=js"
export * from "./ErrorpageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__